import { Injectable } from '@nestjs/common';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { InjectRepository } from '@nestjs/typeorm';
import { Entity, getManager, Repository } from 'typeorm';
import { AllProfilesResponse, ProfileResponse } from '@gtpl/shared-models/hrms';
import { ProfileRequest } from './dto/profile.request';
import { ProfilesDTO } from './dto/profiles.dto';
import { ProfileAdapter } from './dto/profiles.adapter';
import { Profiles } from './profiles.entity';
import { CommonResponse } from '@gtpl/shared-models/masters';


@Injectable()
export class ProfilesService {

    constructor(
        @InjectRepository(Profiles)
        private repository: Repository<Profiles>,
        private adapter: ProfileAdapter,
    ){}

    async getProfile(mobileNumber: string): Promise<Profiles>{
        const response = await this.repository.findOne({
            where: {mobileNumber: mobileNumber},
        });
        if(response){
            return response;
        }else{
            return null;
        }
    }

    async createProfile(data: ProfilesDTO, isUpdate: boolean): Promise<ProfileResponse>{
        try{
            if(!isUpdate){
                const entity = await this.getProfile(data.mobileNumber);
                if(entity){
                    throw new ErrorResponse(11104, 'mobileNumber already exits');
                }
            }else{
                const ProfilesEntity = await this.getProfile(data.mobileNumber);
                if(ProfilesEntity){
                    if(ProfilesEntity.profileId != data.profileId){
                        throw new ErrorResponse(11104, 'Profile already exits');
                    }
                }
            }
            const convertedDto: Profiles = await this.adapter.convertDtoToEntity(data);
            const savedProfile: Profiles = await this.repository.save(convertedDto);
            const convertedProfile: ProfilesDTO = await this.adapter.convertEntityToDto(savedProfile);

            if(convertedProfile){
                const response = new ProfileResponse(true, isUpdate? 11100: 11101, isUpdate? 'Profile updated successfully': 'Profile created successfully', savedProfile);
                return response;
            }else{
                throw new ErrorResponse(11106, 'Profile is saved but error while converting it into DTO');
            }
        }catch(error){
            throw error;
        }
    }

    async getAllProfiles(): Promise<AllProfilesResponse>{
        try{
            const profiles: ProfilesDTO[] = [];
            const entities : Profiles[] = await this.repository.find({
                order: {createdAt: 'DESC'},
            });
            if(entities.length>0){
                entities.forEach(Entity => {
                    const Profiles: ProfilesDTO = this.adapter.convertEntityToDto(Entity);
                    profiles.push(Profiles); 
                    if(Entity.profileId == 57){
                        console.log('entity')
                        console.log(Entity)
                    }
                });
                const response = new AllProfilesResponse(true, 11208, 'Profiles retrieved successfully', profiles);
                return response;
            }else{
                throw new ErrorResponse(99998, 'No Records Found');
            }
        }catch(error){
            throw error;
        }
    }

    async getProfileById(id: number): Promise<Profiles>{
        const response = await this.repository.findOne({
            where: {profileId: id},
        });
        if(response){
            return response;
        }else{
            return null;
        }
    }


    // async updateProfile(updateNotificationDto: UpdateProfile): Promise<AllProfilesResponse> {
    //     const notificationEntity = await this.repository.findOne({
    //         where: { jobId: updateNotificationDto.verificationJobId },
    //     });
    //     if(!notificationEntity) {
    //         throw new ErrorResponse(10000, 'Notification details not found');
    //     } else {
           
    //         await this.repository.save(notificationEntity);  
    //         return new AllProfilesResponse(true, 10000, 'Notification Details Updated Successfully');
    //     }
    // }

    async activateOrDeactivateProfile(req: ProfileRequest): Promise<ProfileResponse>{
        try{
            const ProfilesExists = await this.getProfileById(req.profileId);
            if(ProfilesExists){
                if(req.versionFlag != ProfilesExists.versionFlag){
                    throw new ErrorResponse(10113, 'Someone updated the current Profile information. Refresh and try again');
                }else{
                    const profilestatus = await this.repository.update(
                        {profileId: req.profileId},
                        {isActive: req.isActive, updatedUser: req.updatedUser},
                    );
                    if(ProfilesExists.isActive){
                        if(profilestatus.affected){
                            const response: ProfileResponse= new ProfileResponse(true, 10115, 'Profile is de-activated successfully');
                            return response;
                        }else{
                            throw new ErrorResponse(10111, 'Profile is already de-activated');
                        }
                    }else{
                        if(profilestatus.affected){
                            const response: ProfileResponse = new ProfileResponse(true, 10114, 'Profile is activated successfully');
                            return response;
                        }else{
                            throw new ErrorResponse(10112, 'Profile is already activated');
                        }
                    }
                }
            }else{
                throw new ErrorResponse(99998, 'No Records Found');
            }
        }catch(error){
            throw error;
        }
    }

    async getAllActiveProfiles(): Promise<AllProfilesResponse>{
        try{
            const profiles: ProfilesDTO[] = [];
            const entities: Profiles[] = await this.repository.find({
                order: {profileId: 'ASC'}, where: {isActive: true},
            });
            if(entities.length>0){
                entities.forEach(Entity => {
                    const Profiles: ProfilesDTO = this.adapter.convertEntityToDto(Entity);
                    profiles.push(Profiles); 
                });
                const response = new AllProfilesResponse(true, 11208, 'Profiles retrieved successfully', profiles);
                return response;
            }else{
                throw new ErrorResponse(99998, 'No Records Found');
            }
        }catch(error){
            throw error;
        }
    }


    async getIDJob():Promise<CommonResponse>{
        try{
          const manager=getManager();
          const query = 'SELECT notification_id AS notificationId,job_description AS jobDescription FROM notifications WHERE STATUS not in("Closed","Cancelled") '
          const result = await manager.query(query)
          if(result){
            return new CommonResponse(true, 1111, "Data retreived sucessfully",result)          
          }else{
            return new CommonResponse(false, 1111, "Error occure")
          
          }
            }
            catch(err){
            return err;
            }
          
        }
}
